import React from "react";
import Home from "./AnimatedElements";

export default function FirstSection() {

    return (
        <Home />
    )
}